<style scoped>
    @import url("../../styles/smartControl/exibTextsc.scss");
</style>

<template>
    <div class="box_exibTextsc">

        <div class="boxTit">
            <span class="tit">{{ this.t }}</span>
        </div>

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="boxContent" v-if="flagContent && !flagLoading">
            
            <div class="boxValue">
                <v-icon size="72" class="mr-2 elValue">{{ this.iconEl }}</v-icon>

                <div class="elValue">{{ valor }} {{ this.unid }}</div>

            </div>

            <div class="boxDate">
                <div class="tDate">Última atualização</div>
                <div class="elDate">{{ date }}</div>
            </div>
        </div>

        <div class="semDados" v-if="!flagContent && !flagLoading">
            <v-icon size="42">mdi-emoticon-sad-outline</v-icon>
            <div>{{ msgDados }}</div><!--{{ msgDados }}-->
        </div>

        <!-- botão de abertura de busca #F39C12 -->
        <v-chip @click="callLastReading()" v-if="!flagBtnSearch && !flagLoading"
        class="abrir_leitura"
        color="#397E9E"
        >
            <span>Abrir última leitura</span>
            <!--<v-icon class="ml-1">mdi-cogs</v-icon>-->
        </v-chip>

    </div>
</template>

<script>
import axios from 'axios'

import { convHhmmFromUtc } from "./auxSC/handleTimeConv.js"; // 04/05/2026

export default {

    props:['index','t','iconEl','r','name_key','unid','cliente','sistema','device','deviceStatus'],

    data() {
        return {
            //
            flagLoading:true, // init loading

            //
            flagContent:true, // init false (pré axios)
            msgDados:'AINDA NÃO HÁ DADOS',

            valor:null,
            date:null,

            //
            flagBtnSearch:true, // As leituras dos n primeiros param sensor é buscado.
        }
    },

    methods:{
        //
        callLastReading() {
            if (this.r != "") {

                // SENSOR HABILITADO?
                //console.log('deviceStatus: ',this.deviceStatus)
                if (this.deviceStatus == 'off') {
                    this.msgDados = 'Sensor desabilitado'
                    this.flagContent = false
                    this.flagLoading = false
                    return
                }

                this.flagLoading = true
                this.flagBtnSearch = true // fechar botao

                let params = {

                    'cliente':this.cliente,
                    'sistema':this.sistema,
                    
                    'device':this.device,
                    'sub_marcador':this.name_key,
                    'param':this.t
                }

                const url = this.$store.state.pathAxiosBASE + this.r // -- soma string

                const headers = {
                    'Authorization': `Bearer ${this.$store.state.tox}`,
                    'Content-Type': 'application/json'
                }

                //console.log('[] before axios exibText | this.t: ',this.t)
                //console.log('[] before axios exibText | params: ',params)

                let self = this
                axios.post(url, params, {headers}).then(function (res) {

                    //console.log('ExibText.vue')
                    //console.log(res.data.result)
                    //console.log('self.name_key: ',self.name_key)

                    try {
                        // -- tmp hard code (alterar na origem não no front)
                        // (diferenciação key indice calc vs sensor) 23/03
                        if (self.name_key == 'u_fc') { 
                            let nameKey = 'humidity' 
                            self.valor = res.data.result.rcv_content[nameKey] 
                            //console.log('valor (1): ',self.valor)
                            //console.log('typeof self.valor: ',typeof self.valor)

                            if (typeof self.valor === "undefined") {
                                
                                self.valor = res.data.result.rcv_content[self.name_key]
                            }
                        }
                        else {
                            self.valor = res.data.result.rcv_content[self.name_key]
                        }

                        // -- umidade > 100%?
                        if (self.name_key == 'humidity') {
                            if (parseFloat(self.valor) > 100) { self.valor = 100 }
                        }

                        if (self.valor == 'dark' || self.valor == 'light') { 
                            if (self.valor == 'dark') { self.valor = 'OFF' } else { self.valor = 'ON' }
                        }
                        
                        // -- se float então trunca 2 casas decimais para exibição final.
                        if (Number.isFinite(self.valor) && !Number.isInteger(self.valor)) { self.valor = Math.floor(self.valor * 100) / 100 }
                        
                        // -- conv data utc para local.
                        const dateAndHHmmUTC = res.data.result.date // esperado --> "04/05/2026-11:05"
                        const tzName = self.$store.state.fusoHorarioSC // esperado algo como --> "Europe/Lisbon"
                        //const dataStr = new Date().toLocaleDateString("pt-PT"); // data string no formato pt dd/mm/aaaa
                        const [dataStr, hhmmUTC] = dateAndHHmmUTC.split("-");
                        const hhmmLocal = convHhmmFromUtc(hhmmUTC, tzName, dataStr)
                        self.date = `${dataStr}-${hhmmLocal}`
                        
                        self.flagLoading = false

                    } catch (err) {
                        console.error("Erro:", err.message)

                        if (res.data.result === 'Leituras recentes vazias') {
                            //console.log('leituras vazias');
                            self.msgDados = 'Últimas 10 leituras vazias'
                            self.flagContent = false

                            //self.flagBtnSearch = true
                            self.flagLoading = false
                            return;
                        }

                        self.flagContent = false // ainda nao ha dados
                        self.flagLoading = false
                    }
                    
                    //if (res?.data?.result?.rcv_content?.[self.name_key]) { <-- nao conta o zero...
                    /*if (self.name_key in (res?.data?.result?.rcv_content || {})) {
                        self.valor = res.data.result.rcv_content[self.name_key]

                        // -- umidade > 100%?
                        if (self.name_key == 'humidity') {
                            if (parseFloat(self.valor) > 100) { self.valor = 100 }
                        }

                        if (self.valor == 'dark' || self.valor == 'light') { 
                            if (self.valor == 'dark') { self.valor = 'OFF' } else { self.valor = 'ON' }
                        }
                        
                        // -- se float então trunca 2 casas decimais para exibição final.
                        if (Number.isFinite(self.valor) && !Number.isInteger(self.valor)) { self.valor = Math.floor(self.valor * 100) / 100 }
                        
                        self.date = res.data.result.date
                        self.flagLoading = false
                    }
                    else { 
                        
                        //if (typeof result === 'string' && res.data.result.includes('Leituras recentes vazias')) {
                        if (res.data.result === 'Leituras recentes vazias') {
                            //console.log('leituras vazias');
                            self.msgDados = 'Últimas 10 leituras vazias'
                            self.flagContent = false

                            //self.flagBtnSearch = true
                            self.flagLoading = false
                            return;
                        }

                        self.flagContent = false // ainda nao ha dados
                        self.flagLoading = false
                    }*/
                    
                    //console.log('self.valor: ', self.valor)
                    //console.log('self.date: ', self.date)
                })
            }
        },
    },

    created() {
        //console.log('t: ',this.t)
        
        // -- buscar os 3 primeiros elementos para evitar sobrecarga.
        if (this.index < 2) { 
            this.flagBtnSearch = true
            this.callLastReading() 
        }
        else {

            this.flagBtnSearch = false // a partir daqui, o botão de buscar é disponibilizado.
            this.flagLoading = false // loading seria desnecessario
        }

    }
}
</script>